export default "__VITE_ASSET__DI5dSgEH__"